exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".social-img{width:65% !important;cursor:pointer}.social-link-container{margin-bottom:10px;text-align:center;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/SocialLink/styles.scss
// module id = 749
// module chunks = 0